import {BaseMobxStore} from "../../../../infrastructure/mobx/base-mobx-store";
import {BottomMessageModuleConfig} from "./bottom-message-module.config";
import {BottomMessageModuleState} from "./models/bottom-message-module.state";

export class BottomMessageModuleStore extends BaseMobxStore {
  static injectables = [BottomMessageModuleConfig, BottomMessageModuleState];
}

